var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(-6322 -3454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2370",
    "data-name": "Rectangle 2370",
    width: 24,
    height: 24,
    transform: "translate(6322 3454)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(2953.982 336.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M3387.87,3121.894c0-1.03-.006-2.038,0-3.047a.852.852,0,0,1,1.185-.814.817.817,0,0,1,.525.774q.006,2.57,0,5.142a.851.851,0,0,1-.671.859q-2.474.827-4.95,1.649a.867.867,0,1,1-.533-1.636c1.125-.377,2.251-.748,3.377-1.123.083-.028.166-.059.345-.123-.272-.247-.5-.464-.74-.67a9.435,9.435,0,0,0-15.679,6.984.861.861,0,1,1-1.713-.033,10.986,10.986,0,0,1,4.576-8.9,10.413,10.413,0,0,1,5.007-2.021,10.943,10.943,0,0,1,9.088,2.852c.033.029.066.061.1.088A.3.3,0,0,0,3387.87,3121.894Z",
    transform: "translate(0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    "data-name": "Path 3005",
    d: "M3387.475,3229.219c.161.171.286.321.428.452a9.253,9.253,0,0,0,7.3,2.565,9.383,9.383,0,0,0,8.457-7.521,13.456,13.456,0,0,0,.18-1.781.892.892,0,0,1,.886-.934.871.871,0,0,1,.832.953,10.982,10.982,0,0,1-4.59,8.92,10.394,10.394,0,0,1-4.984,2.01,10.947,10.947,0,0,1-9.09-2.843c-.045-.041-.094-.079-.169-.143-.008.1-.018.179-.018.252,0,.92,0,1.839,0,2.759a.861.861,0,1,1-1.714,0q0-2.477,0-4.954a.873.873,0,0,1,.69-.954q2.475-.827,4.95-1.65a.864.864,0,1,1,.552,1.629c-1.132.384-2.268.755-3.4,1.133Z",
    transform: "translate(-14.26 -92.894)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.740d4675.svg";
export { ForwardRef as ReactComponent };